export default "__VITE_ASSET__7c1aa0ff__"